<template>
    <v-container>
        <h2>この契約の関係者</h2>
        <v-timeline align-top dense>
            <div class="timeline-wrap" v-for="(item, index) in items" :key="index">
                <v-timeline-item v-if="item.step === step" color="pink" small class="current"><p>{{ item.title }}</p></v-timeline-item>
                <v-timeline-item v-else-if="item.step > step" color="grey"  class="after" small><p>{{ item.title }}</p></v-timeline-item>
                <v-timeline-item v-else color="pink" small><p>{{ item.title }}</p></v-timeline-item>
            </div>
        </v-timeline>
    </v-container>
</template>

<script>
    export default {
        props: ['step', 'destinations'],
        data: () => ({
            items: [
            ],
        }),
        created: function () {
            this.items = this.destinations;
        }
    };
</script>
